
import Vue from 'vue'
import RangeSlider from '@/common/components/RangeSlider.vue'
import NumberInput from '@/common/components/NumberInput.vue'
import { MaxQuantityPrice  } from '@/common/types/maxQuantityPrice'

export default Vue.extend({
  name: 'TopSearchControl',
  components: {
    RangeSlider,
    NumberInput
  },
  props: {
    categoryName: {
      type: String,
      default:''
    },
    categoryId: {
      type: Number,
      default: null
    },
    showCategory: {
      type: Boolean,
      default: false
    },
    maxQuantityPrice: {
      type: Object as () => MaxQuantityPrice,
      required: true
    }
  },
  data(): {
    minRange: number
    maxRange: number
    minThreshold: number
    inputQuantity: number
    minInputValidate: boolean
    maxInputValidate: boolean
  } {
    return {
      minRange: 1,
      maxRange: 0,
      minThreshold: 1,
      inputQuantity: 0,
      minInputValidate: false,
      maxInputValidate: false
    }
  },
  computed: {
    disableButton(): boolean {
      return this.errorMessage != ''
    },
    errorMessage(): string {
      let error = ''
      if (this.maxThreshold){
        if (isNaN(this.maxRange) ||
          isNaN(this.minRange) ||  isNaN(this.inputQuantity)){
          error =  '半角数字で入力してください'
        } else if (this.minRange > this.maxRange ||
          this.maxRange < this.minRange ||
          this.minRange < this.minThreshold ||
          this.maxRange > this.maxThreshold ||
          this.validateInputForm){
          error =  '最小値は最大値より低いです。'
        }
      }
      return error
    },
    validateInputForm(): boolean {
      return (
        this.inputQuantity == 0 &&
        this.minInputValidate &&
        this.maxInputValidate
      )
    },
    maxThreshold(): number {
      return this.maxQuantityPrice.max_price
    },
    maxQuantityValue(): number {
      return this.maxQuantityPrice.max_quantity
    },
    maxRangeValue(): number {
      return this.maxRange !== undefined ? this.maxRange : this.maxThreshold
    },
    minRangeValue(): number {
      return this.minRange !== undefined ? this.minRange : this.minThreshold
    },
    quantityValue(): number | string {
      return this.inputQuantity == 0 ? '' : this.inputQuantity
    }
  },
  watch: {
    maxThreshold: {
      immediate: true,
      handler(value: number) {
        this.maxRange = value
      }
    }
  },
  methods: {
    inputValueHandler(value: number) {
      this.inputQuantity = value
    },
    rangeValuesHandler(value: { [key: string]: number }) {
      this.minRange = value.min
      this.maxRange = value.max
    },
    minInputValidateHandler(value: boolean) {
      this.minInputValidate = value
    },
    maxInputValidateHandler(value: boolean) {
      this.maxInputValidate = value
    },
    goToSearchPage() {
      const category = this.categoryId || ''
      location.href = `/search?category=${category}&max=${this.maxRangeValue}&min=${this.minRangeValue}&quantity=${this.quantityValue}`
    }
  }
})
